const swift = swift =>
  !swift ||
  /^[A-Z]{6,6}[A-Z2-9][A-NP-Z0-9]([A-Z0-9]{3,3}){0,1}$/.test(
    swift.toUpperCase()
  )

export default swift
